import { Button, ButtonProps, Intent } from '@blueprintjs/core';
import { useAppDispatch } from '../../hooks';
import { previousStep } from '../../views/workflow/reducer';

const PreviousButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch();

  return (
    <Button
      {...props}
      icon="chevron-left"
      intent={Intent.PRIMARY}
      fill
      onClick={() => dispatch(previousStep())}
    >
      Voltar
    </Button>
  );
};

export default PreviousButton;
